import { AnyFramework } from "@storybook/csf";
import React from "react";

const Inventory = ({ isActive }: any) => {
  return (
    <svg
      width="20"
      height="32"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6626 5.90257L10.2626 1.10257C9.89333 0.825601 9.44424 0.675781 8.98261 0.675781C8.52099 0.675781 8.07189 0.825601 7.70261 1.10257L1.30261 5.90257C0.76547 6.30542 0.449219 6.93777 0.449219 7.60917V17.2092C0.449219 17.7749 0.674042 18.3176 1.07404 18.7177C1.47422 19.1177 2.0169 19.3426 2.58261 19.3426H15.3826C15.9483 19.3426 16.491 19.1177 16.8912 18.7177C17.2912 18.3176 17.516 17.7749 17.516 17.2092V7.60917C17.516 6.93772 17.1998 6.3054 16.6626 5.90257ZM8.44913 12.9426H4.71592V8.67578H8.44913V12.9426ZM4.71592 18.2756V14.009H8.44913V18.2756H4.71592ZM9.51591 18.2756V14.009H13.2491V18.2756H9.51591ZM16.4489 17.209C16.4488 17.4918 16.3363 17.7629 16.1363 17.9629C15.9363 18.1629 15.6652 18.2754 15.3823 18.2756H14.3157V14.009C14.3157 13.7261 14.2032 13.4547 14.0032 13.2547C13.8032 13.0547 13.532 12.9424 13.249 12.9424H9.51556V8.67558C9.51556 8.39273 9.40324 8.12148 9.20324 7.92148C9.00324 7.7213 8.73184 7.60898 8.44896 7.60898H4.71575C4.43271 7.60898 4.16146 7.7213 3.96146 7.92148C3.76146 8.12148 3.64896 8.39275 3.64896 8.67558V18.2756H2.58236C2.2995 18.2754 2.02844 18.1629 1.82844 17.9629C1.62844 17.7629 1.51594 17.4918 1.51576 17.209V7.60899C1.51647 7.27345 1.67433 6.95756 1.94237 6.75559L8.34237 1.95559C8.52701 1.8172 8.75165 1.74238 8.98237 1.74238C9.21308 1.74238 9.43772 1.8172 9.62237 1.95559L16.0224 6.75559C16.2904 6.95756 16.4483 7.27345 16.449 7.60899L16.4489 17.209Z"
        fill={isActive ? "#5F67E0" : "#1A1B1B"}
      />
    </svg>
  );
};

export default Inventory;
